import React from "react";
import { Modal, Button, Tabs, Icon } from "antd";
import { useTranslation } from "react-i18next";
import AudienceResumenChart from "./AudienceResumenChart";
import AudienceProviderInfo from "./AudienceProviderInfo";
import GenerateSkeleton from "./GenerateSkeleton";

const { TabPane } = Tabs;

const CampaignAudienceModal = ({ visible, displays, proposalAudience, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("Audience summary")}
      visible={visible}
      onCancel={onClose}
      width={1000}
      style={{ top: 10 }}
      footer={[
        <Button key="ok" onClick={onClose}>
          OK
        </Button>,
      ]}
    >
      <Tabs defaultActiveKey="1">
        <TabPane
          tab={
            <span>
              <Icon type="edit" /> {t("Audience")}
            </span>
          }
          key="1"
        >
          <AudienceProviderInfo displays={displays} />
          {proposalAudience ? (
            <AudienceResumenChart proposalAudience={proposalAudience} />
          ) : (
            <GenerateSkeleton height={400} />
          )}
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default CampaignAudienceModal;
